<!--Pagination-->
<div class="d-flex justify-content-between mt-3" *ngIf="total">
  <div class="d-flex align-items-center">
    <span class="mr-2">Số hàng hiển thị</span>
    <select
      class="form-control mr-2"
      style="width: 80px"
      [(ngModel)]="size"
      (ngModelChange)="loadPageSizeEvent($event)"
    >
      <option *ngFor="let item of sizes" [value]="item.size">
        {{ item.name }}
      </option>
    </select>
    <span>Hiện {{ start }} - {{ end }} trong số {{ total }}</span>
  </div>
  <!-- <div class="info">
    Hiển thị kết quả từ
    {{ (page - 1) * size == 0 ? 1 : (page - 1) * size + 1 }}
    - {{ page * size < total ? page * size : total }} trên tổng {{ total }}
  </div> -->

  <ul class="pagination pg-blue justify-content-end">
    <!--Arrow left-->
    <li class="page-item" [ngClass]="!checkPrevious() ? 'disabled-button' : ''">
      <span class="page-link" (click)="totalPage > 1 && first()">
        <!-- Trang Đầu -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
        >
          <path
            d="M3.604 5.50049L9.11157 0.000976803L10.265 1.15271L5.91082 5.50049L10.265 9.84826L9.11157 11L3.604 5.50049Z"
            fill="#828282"
          />
          <rect
            x="1.85791"
            y="11"
            width="1.5022"
            height="11"
            transform="rotate(-180 1.85791 11)"
            fill="#828282"
          />
        </svg>
      </span>
    </li>
    <!-- <li class="page-item" *ngIf="totalPage > 5" [ngClass]="!checkFirst() ? 'disabled-button' : ''">
      <span class="page-link" (click)="changePage(selectedPage - 5)">
        <i aria-hidden="true" class="fa fa-step-backward"></i>
      </span>
    </li> -->
    <li class="page-item" [ngClass]="!checkPrevious() ? 'disabled-button' : ''">
      <span class="page-link" (click)="previous()">
        <!-- <i class="fa fa-caret-left fa-lg" aria-hidden="true"></i> -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="11"
          viewBox="0 0 8 11"
          fill="none"
        >
          <path
            d="M0.405761 5.50049L5.91333 0.000976803L7.06675 1.15271L2.71258 5.50049L7.06675 9.84826L5.91332 11L0.405761 5.50049Z"
            fill="#828282"
          />
        </svg>
      </span>
    </li>
    <li class="page-item" *ngFor="let item of pages; index as index">
      <span
        class="page-link"
        (click)="changePage(item)"
        [ngClass]="
          item === selectedPage ? 'active-link background-active-link' : ''
        "
      >
        {{ item }}
        <span class="sr-only">(current)</span>
      </span>
    </li>
    <li class="page-item">
      <span
        class="page-link"
        [ngClass]="!checkNext() ? 'disabled-button' : ''"
        (click)="next()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="11"
          viewBox="0 0 8 11"
          fill="none"
        >
          <path
            d="M7.1167 5.49951L1.60914 10.999L0.455713 9.84729L4.80988 5.49951L0.455713 1.15174L1.60914 -6.5581e-08L7.1167 5.49951Z"
            fill="#828282"
          />
        </svg>
      </span>
    </li>
    <!-- <li class="page-item" *ngIf="totalPage > 5" [ngClass]="selectedPage === totalPage ? 'disabled-button' : ''">
      <span class="page-link" (click)="changePage(selectedPage + 5)">
        <i aria-hidden="true" class="fa fa-step-forward"></i>
      </span>
    </li> -->
    <li class="page-item">
      <span
        class="page-link"
        (click)="totalPage > 1 && last()"
        [ngClass]="!checkNext() ? 'disabled-button' : ''"
        title="Trang cuối"
      >
        <!-- Trang Cuối -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="11"
          viewBox="0 0 10 11"
          fill="none"
        >
          <path
            d="M6.75195 5.49951L1.24439 10.999L0.0909667 9.84729L4.44513 5.49951L0.0909663 1.15174L1.24439 2.40391e-07L6.75195 5.49951Z"
            fill="#828282"
          />
          <rect x="8.49756" width="1.5022" height="11" fill="#828282" />
        </svg>
      </span>
    </li>
  </ul>
</div>
